import { useState, useEffect } from 'react';
import { db } from '../lib/db';

export default function CompanySettings() {
  const [settings, setSettings] = useState({
    name: '',
    cnpj: '',
    phone: '',
    logo_url: '',
    website: ''
  });
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadSettings() {
      try {
        const sessionRaw = localStorage.getItem("revisapro.session.v2");
        const session = sessionRaw ? JSON.parse(sessionRaw) : null;
        const res = await fetch('/api/settings/company', {
          headers: { "Authorization": `Bearer ${session?.token}` }
        });
        if (res.ok) {
          const data = await res.json();
          setSettings(data || { name: '', cnpj: '', phone: '', logo_url: '', website: '' });
        }
      } catch (e) {
        console.error("Erro ao carregar configurações", e);
      } finally {
        setLoading(false);
      }
    }
    loadSettings();
  }, []);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === 'logo_url' && value.includes('drive.google.com/file/d/')) {
      const match = value.match(/\/d\/([a-zA-Z0-9_-]+)/);
      if (match && match[1]) {
        value = `https://drive.google.com/uc?export=view&id=${match[1]}`;
      }
    }
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const sessionRaw = localStorage.getItem("revisapro.session.v2");
      const session = sessionRaw ? JSON.parse(sessionRaw) : null;
      
      const res = await fetch('/api/settings/company', {
        method: "POST",
        headers: { 
          "Authorization": `Bearer ${session?.token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(settings)
      });

      if (!res.ok) throw new Error("Erro ao salvar no servidor");
      alert('Configurações da empresa salvas com sucesso!');
    } catch (e) {
      console.error(e);
      alert('Erro ao salvar configurações.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="p-8 text-center text-gray-500">Carregando...</div>;
  }

  return (
    <div className="p-8 max-w-2xl mx-auto animate-fade-in">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Minha Empresa</h1>
        <p className="text-gray-500 mt-2 text-sm">Configure os dados globais que aparecerão nas suas propostas e faturas.</p>
      </div>

      <div className="bg-white/70 backdrop-blur-xl border border-white/40 shadow-xl rounded-2xl p-6 md:p-8 relative overflow-hidden group">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-red/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
        
        <form onSubmit={handleSave} className="relative z-10 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">Nome da Empresa / Profissional</label>
              <input
                type="text"
                name="name"
                value={settings.name}
                onChange={handleChange}
                placeholder="Ex: RevisaPro Ltda"
                className="w-full bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-brand-red focus:border-brand-red block p-3 transition-all"
              />
            </div>
            
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">CNPJ / CPF</label>
              <input
                type="text"
                name="cnpj"
                value={settings.cnpj}
                onChange={handleChange}
                placeholder="00.000.000/0000-00"
                className="w-full bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-brand-red focus:border-brand-red block p-3 transition-all"
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">WhatsApp Comercial</label>
              <input
                type="text"
                name="phone"
                value={settings.phone}
                onChange={handleChange}
                placeholder="(00) 00000-0000"
                className="w-full bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-brand-red focus:border-brand-red block p-3 transition-all"
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">Site (Opcional)</label>
              <input
                type="url"
                name="website"
                value={settings.website}
                onChange={handleChange}
                placeholder="https://suaempresa.com.br"
                className="w-full bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-brand-red focus:border-brand-red block p-3 transition-all"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700">URL do Logotipo (Opcional)</label>
            <input
              type="url"
              name="logo_url"
              value={settings.logo_url}
              onChange={handleChange}
              placeholder="https://..."
              className="w-full bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-brand-red focus:border-brand-red block p-3 transition-all"
            />
            {settings.logo_url && (
              <div className="mt-4 p-4 bg-gray-50 rounded-xl border border-gray-100 flex justify-center">
                <img src={settings.logo_url} alt="Logo" className="max-h-16 object-contain" />
              </div>
            )}
          </div>

          <div className="pt-4 border-t border-gray-100 flex justify-end">
            <button
              type="submit"
              disabled={saving}
              className="bg-brand-red hover:bg-red-700 text-white font-medium py-3 px-8 rounded-xl transition-all active:scale-95 disabled:opacity-50"
            >
              {saving ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
